<script setup>
import Layout from "@/layouts/main.vue";
import { onMounted, computed, ref} from 'vue';
import PageHeader from "@/components/page-header";
// import appConfig from "../../../app.config";
import Idle from "@/components/traffic-records/idle.vue";
import TrafficRecordComponents from "@/components/traffic-record-components.vue"
import { authHeader } from './../../helpers/authservice/auth-header';
import { useStore } from 'vuex'
import axios from 'axios';

const store = useStore();
const user = computed(() => store.state.auth.user);
const phase_id = ref(null);
const title = ref("Review");
const items = ref([
    {
        text: "Home",
    },
    {
        text: "Traffic Records",
    },
    {
        text: "Review",
        active: true,
    }
]);

const userRoles = JSON.parse(localStorage.getItem('roles'));

const roleExist = (slug) => {
  if (userRoles && userRoles.length) {
      return userRoles.some((obj) => (obj.slug === slug));
  }

  return false;
}

const getVerifyValidateCount = async () => {
    store.dispatch('globals/loading', null, { root: true });

    try {
      const {data} = await axios.get(`/queue/${user.value.id}/verify-validate-count`, {
        headers: authHeader()
      });

      title.value = `1st Review: ${data.verify} - 2nd Review: ${data.unfiltered_validate}`;

      if(data.validate == 0 || data.active_verify){
        // IF VALIDATE PENDING COUNT IS ZERO OR QUEUE HAS ACTIVE VERIFY QUEUE; QUEUE VERIFY
        phase_id.value = 2
      }else if(data.verify == 0 || data.active_validate){
        // IF VERIFY PENDING COUNT IS ZERO OR QUEUE HAS ACTIVE VALIDATE QUEUE; QUEUE VALIDATE
        phase_id.value = 3
      }else{
        // IF VERIFY AND VALIDATE ARE NOT ZERO PRIORITIZED VALIDATE WHEN USER IS ADDITIONAL REVIEWER
        if(roleExist('one-pass-review')){
          phase_id.value = 3
        }else{
          phase_id.value = 2
        }
        // phase_id.value = Math.floor(Math.random() * (3 - 2 + 1)) + 2
      }

      // console.log(data);
      // console.log(phase_id.value);
      store.dispatch('globals/loaded', null, { root: true });
    } catch (err) {
      console.log(err);
      store.dispatch('globals/loaded', null, { root: true });
    }
}

onMounted(async () => {
    await getVerifyValidateCount();
});

</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <Idle />
    <TrafficRecordComponents v-if="phase_id" :phase_id="phase_id" />
  </Layout>
</template>
